module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.ade10ffa.woff";